import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0px 10px',
  background: theme.palette.background.paper, //theme.WHITE
  border: `1px solid ${theme.palette.primary.light}`, //theme.PRIMARY_80
}))

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 500,
  fontSize: '24px',
  lineHeight: '32.02px',
}))
